{
  "chapel": {
    "u": -1,
    "v": 19.8,
    "angleDeg": -7.8,
    "u0": -30,
    "chordU": 0,
    "vc": 0,
    "half": 4.3,
    "eaveY": 13.4,
    "ridgeY": 20.2
  },
  "belfry": {
    "u": -23,
    "v": 0,
    "radius": 0.48,
    "foot": 18.3,
    "eaves": 20.3,
    "tip": 25.4
  },
  "ranges": [
    {
      "id": "southern-gabled-range",
      "u": -0.5,
      "v": -14.5,
      "angleDeg": 0,
      "length": 53,
      "width": 8.2,
      "eaves": 11.2,
      "ridge": 16.8,
      "floors": 3,
      "bays": 11,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-22.5, -17.5, -12.5, -7.5, -2.5, 2.5, 7.5, 12.5, 17.5, 22.5],
        "halfWidth": 0.8,
        "v0": 0.85,
        "v1": 4.1,
        "eaves": 16.0,
        "ridge": 17.9,
        "sill": 14.2,
        "top": 15.3
      }
    },
    {
      "id": "nes-range",
      "u": -28.55,
      "v": 2.0,
      "angleDeg": -77,
      "length": 37,
      "width": 6.0,
      "eaves": 10.3,
      "ridge": 15.4,
      "floors": 3,
      "bays": 6,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-10, -5, 0, 5, 10],
        "halfWidth": 0.85,
        "v0": 0.85,
        "v1": 3.0,
        "eaves": 14.3,
        "ridge": 16.2,
        "sill": 12.5,
        "top": 13.600000000000001
      }
    },
    {
      "id": "canal-gate-range",
      "u": 28.3,
      "v": -0.5,
      "angleDeg": -103,
      "length": 31,
      "width": 6.2,
      "eaves": 10.6,
      "ridge": 15.4,
      "floors": 3,
      "bays": 7,
      "roof": "slate",
      "passage": 3.2,
      "roofGables": {
        "centres": [-12, -7, 3, 8, 13],
        "halfWidth": 0.8,
        "v0": 0.85,
        "v1": 3.1,
        "eaves": 14.3,
        "ridge": 16.2,
        "sill": 12.5,
        "top": 13.600000000000001
      },
      "passageU": -2
    },
    {
      "id": "northern-canal-range",
      "u": 14.852,
      "v": 17.6286,
      "angleDeg": -7.8,
      "length": 32,
      "width": 8.6,
      "eaves": 8.5,
      "ridge": 13.4,
      "floors": 2,
      "bays": 6,
      "roof": "slate",
      "passage": 0
    }
  ],
  "floors": [
    {
      "ring": [
        [-24.5, -10.3],
        [25.5, -10.3],
        [28.1, 11.7],
        [-28.5, 15.8]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-21, -7],
        [22.4, -7],
        [24.5, 8.8],
        [-25, 12.5]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [],
  "note": "Sint Margriet is read body by body from the 1538 painting and labelled 1544 woodcut: a shorter northern chapel at the Nes end and a lower range continuing toward the canal, tall southern gabled body, unequal Nes and canal ranges and a long open court. The anonymous 1760 print RP-P-AO-24X-2 explicitly derives its interpretation from the 1544 map, not an independent medieval survey. The neighbouring Pieters chapel and hospital are separate institutions; their later meat-market names and alterations are not backdated. All component dimensions, angles, elevations, roof gables, belfry, windows, private passage, soil boundaries and dry precinct edge are fitted estimates. The 1415-1419 chapel chronology does not date the precise building depicted in 1538. The complete property boundaries and internal room functions remain unresolved; neither a four-equal-wing cloister nor the later Brakke Grond square is assumed."
}
